import React from "react"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
} from "chart.js"
import { Bar } from "react-chartjs-2"

interface BarChartProps {
  data: {
    대전Data: any
    보령Data: any
    여수Data: any
    정읍Data: any
  }
  height?: string
  width?: string
}

// Chart.js 플러그인 등록
ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip)

const Page3Barchart3: React.FC<BarChartProps> = ({
  data: { 정읍Data, 대전Data, 보령Data, 여수Data },
  height = "300px",
  width = "500px",
}) => {
  const labels = ["정읍", "대전", "보령", "여수"]

  // tradeList에서 sellCost와 buyCost의 합계 계산
  const calculateSum = (data: any | undefined, type: "sellCost" | "buyCost") =>
    Number(
      data?.tradeList?.reduce(
        (sum: number, trade: any) => sum + (trade[type] || 0),
        0
      )
    )
      .toFixed(0)
      .toLocaleString() || 0

  const chartData = {
    labels,
    datasets: [
      {
        label: "판매량",
        data: [
          calculateSum(정읍Data, "sellCost"),
          calculateSum(대전Data, "sellCost"),
          calculateSum(보령Data, "sellCost"),
          calculateSum(여수Data, "sellCost"),
        ],
        backgroundColor: "#4282EF",
        borderRadius: 5,
      },
      {
        label: "구매량",
        data: [
          calculateSum(정읍Data, "buyCost"),
          calculateSum(대전Data, "buyCost"),
          calculateSum(보령Data, "buyCost"),
          calculateSum(여수Data, "buyCost"),
        ],
        backgroundColor: "#B89EFA",
        borderRadius: 5,
      },
    ],
  }

  const options: import("chart.js").ChartOptions<"bar"> = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: false,
        },
        ticks: {
          callback: (value) =>
            `${Number(Number(value) / 10000)
              .toFixed(0)
              .toLocaleString()} 만원`, // y축 값에 % 추가
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
      tooltip: {
        enabled: true, // 툴팁 활성화
        callbacks: {
          label: function (tooltipItem) {
            return `${tooltipItem.dataset.label}: ${Number(
              (Number(tooltipItem.raw) / 10000).toFixed(0)
            )?.toLocaleString()} 만원`
          },
        },
      },
    },
  }

  return (
    <div style={{ height, width }}>
      <Bar data={chartData} options={options} />
    </div>
  )
}

export default Page3Barchart3
